import { globalHistory } from '@reach/router';
import SweetScroll from 'sweet-scroll';

export const updateHeaderOption = scroll => {
  if (scroll) {
    const headerDom1 = document.getElementsByClassName('header-container');
    const headerDom2 = document.getElementsByClassName('website-header');
    const headerHeight1 = headerDom1 && headerDom1.length > 0 ? headerDom1[0].clientHeight : false;
    const headerHeight2 = headerDom2 && headerDom2.length > 0 ? headerDom2[0].clientHeight : 0;
    const scrollOptions = {
      trigger: 'a[href^="#"]',
      updateURL: true,
      offset: -((headerHeight1 || headerHeight2) + 20),
    };
    scroll.update(scrollOptions);
  }
};

const sweetScroll = (options = {}) => {
  if (typeof window !== 'undefined') {
    const scroll = new SweetScroll({
      ...options,
    });
    updateHeaderOption(scroll);
    return scroll;
  }
  return null;
};

export const scrollToAnchor = id => {
  sweetScroll().to(id);
};

export const scrollToAnchorOnLoad = () => {
  const { hash } = globalHistory.location;

  if (hash && !hash.startsWith('#code=')) {
    setTimeout(() => {
      sweetScroll().to(hash);
    });
  }
};

export default sweetScroll;
